import { TABLET_API_ORIGIN } from '@/global/env';
import { RestClientInterface } from '@/lib/restClient';

import {
  StoreManagementAssociateBrandCreateParams,
  StoreManagementAssociateBrandCreateResponse,
  StoreManagementBrandSearchListParams,
  StoreManagementSearchListResponse,
} from './hooks';

interface Interface {
  searchList: (
    params: StoreManagementBrandSearchListParams
  ) => Promise<StoreManagementSearchListResponse>;
}

export class StoreManagementBrandService implements Interface {
  constructor(private readonly restClient: RestClientInterface) {}

  public async searchList(
    params: StoreManagementBrandSearchListParams
  ): Promise<StoreManagementSearchListResponse> {
    const queryParams = new URLSearchParams();
    queryParams.append('limit', String(params.limit));
    queryParams.append('current_page', String(params.currentPage));
    return await this.restClient.get<StoreManagementSearchListResponse>(
      `${TABLET_API_ORIGIN}/dashboard-api/brands?${queryParams.toString()}` as const
    );
  }

  public async create(
    params: StoreManagementAssociateBrandCreateParams
  ): Promise<StoreManagementAssociateBrandCreateResponse> {
    return await this.restClient.post(
      `${TABLET_API_ORIGIN}/dashboard-api/brands` as const,
      params
    );
  }
}
